export default function (indirizzo) {
  this.id = indirizzo ? indirizzo.id : null;
  this.Indirizzo = indirizzo ? indirizzo.Indirizzo : null;
  this.Cap = indirizzo ? indirizzo.Cap : null;
  this.LocalitaIndirizzo = indirizzo ? indirizzo.LocalitaIndirizzo : null;
  this.ProvinciaIndirizzo = indirizzo ? (indirizzo.ProvinciaIndirizzo ? indirizzo.ProvinciaIndirizzo.toUpperCase() : null) : null;
  this.CittaIndirizzo = indirizzo ? indirizzo.CittaIndirizzo : null;
  this.NazioneIndirizzo = indirizzo ? (indirizzo.NazioneIndirizzo ? indirizzo.NazioneIndirizzo.toUpperCase() : 'IT') : 'IT';
  this.Presso = indirizzo ? indirizzo.Presso : null;
  this.isPrincipale = indirizzo ? indirizzo.isPrincipale : false;
}